module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Black.3b6dd2a4.woff2";